import { CloseCircleOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { AutomationStatus } from '@repo/utils';
import { automationStatusSelector } from 'automations/selectors/automationConfig';
import { useSelector } from 'react-redux';

import UpateStatusButton from '../UpateStatusButton';

export default function UpdateStatus() {
  const automationStatus = useSelector(automationStatusSelector);

  if (!automationStatus) return null;

  switch (automationStatus) {
    case AutomationStatus.draft:
      return (
        <UpateStatusButton
          newStatus={AutomationStatus.published}
          buttonProps={{
            size: 'large',
            icon: <PlayCircleOutlined />,
            type: 'primary',
          }}
          successButton
        >
          Publish
        </UpateStatusButton>
      );

    case AutomationStatus.unpublished:
      return (
        <UpateStatusButton
          newStatus={AutomationStatus.published}
          buttonProps={{
            size: 'large',
            icon: <PlayCircleOutlined />,
            type: 'primary',
          }}
          successButton
        >
          Re-Publish
        </UpateStatusButton>
      );

    case AutomationStatus.published:
      return (
        <UpateStatusButton
          newStatus={AutomationStatus.unpublished}
          buttonProps={{
            size: 'large',
            icon: <CloseCircleOutlined />,
            type: 'primary',
            danger: true,
            ghost: true,
          }}
        >
          Unpublish
        </UpateStatusButton>
      );

    default:
      return null;
  }
}
